import {
  ScheduledCode,
} from "../../redux/types/hubs";

// export const getHubScheduledCodesForUpdate = (scheduledCodes: ScheduledCode[]): ScheduledCode[] => {
//   const arr: ScheduledCode[] = [];
//   for (const [slot, value] of Object.entries(scheduledCodes)) {
//     arr.push({ ...value, slot });
//   }
//   return arr;
// };

export const getFreeSlot = (scheduledCodes: ScheduledCode[]): string => {
  const reservedSlots = ['6', '7', '8', '9', '10'];
  const slots = scheduledCodes.map((c) => c.slot);
  let slot = 2;

  while (slots.includes(slot) || reservedSlots.includes(slot.toString())) {
    slot += 1;
  }

  return slot.toString();
};
